import { ExperienceWidget } from '../models/experience-widget.model';

export class AddExperienceWidgets {
    static readonly type = '[ExperienceWidget] AddExperienceWidget';

    constructor(public payload: ExperienceWidget[]) {}
}
